var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A3A3A9",
    d: "M5 6h13v13H5zM21 6h22v2H21zM21 10h22v2H21zM21 14h22v2H21zM5 22h38v2H5zM5 26h38v2H5zM5 34h38v2H5zM5 30h38v2H5zM5 38h38v2H5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A3A3A9",
    strokeWidth: 2,
    d: "M1 1h46v46H1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoPage);
export default __webpack_public_path__ + "static/media/lo-page.9d510eee0b72c206c689ab7204ba3996.svg";
export { ForwardRef as ReactComponent };